import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { palette } from '../../../../styles/colors';

const StyledFooterAnchor = css`
  display: flex;
  width: fit-content;

  p {
    justify-content: flex-start;
  }

  p:after {
    transition: all ease-in-out 0.2s;
    background: none repeat scroll 0 0 #ffffff;
    content: '';
    display: block;
    height: 1px;
    width: 0px;
  }

  &:hover > p:after {
    width: 100%;
  }
`;

export const LinkGroupContainer = styled.div`
  display: grid;
  row-gap: 0.875em;
  align-self: start;
  color: ${palette.white};

  & > a {
    text-decoration: none;
    color: ${palette.fog};
  }
`;

export const StyledFooterA = styled.a`
  ${StyledFooterAnchor}
`;

export const StyledFooterLink = styled(Link)`
  ${StyledFooterAnchor}
`;
